module.exports = __webpack_public_path__ + "media/images/sankro-full-1-6c603470fa3a8a76a79bcbf24eaa62a2.png";